import { Frequency, RRule, RRuleSet } from "rrule";
import { convertDateToUtc } from "./convertDateToUtc";

/**
 * Gets RRule for a single item.
 * @param date Start date.
 */
export function getSingleItemRRule(date: Date): RRuleSet {
    const rruleSet = new RRuleSet();
    rruleSet.rrule(new RRule({
        dtstart: convertDateToUtc(date),
        freq: Frequency.YEARLY,
        count: 1,
    }));

    return rruleSet;
}
